import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FeatureFlagService } from '@icullen/api/shared';

@Component({
  selector: 'cullen-footer',
  templateUrl: './cullen-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./cullen-footer.component.scss'],
})
export class CullenFooterComponent implements OnInit {
  todayDate = new Date();

  constructor(
    public featureFlagService: FeatureFlagService
  ) {}

  ngOnInit() {}
}
